module.exports = __webpack_public_path__ + "img/modal-createpub-icon.dcc06db2.png";